import React, { useState } from "react";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import PiAccountDialog from "./PiAccountPopover";
import PiSwitchOrganizationDialog from "./PiSwitchOrganizationDialog";
import { useSelector } from "react-redux";
import {
  selectCurrentOrganization,
  selectUsername,
} from "../../app/slices/UserSlice";
import "./PiAccountButton.css";
import SettingsModal from "./SettingsModal";
import classNames from "classnames";
interface PiUserButtonProps {
  isMenuExpanded: boolean;
}

export default function PiUserButton(props: PiUserButtonProps) {
  const [openAccountDialog, setOpenAccountDialog] = useState(false);
  const [openSwitchOrganizationDialog, setOpenOrganizationDialog] =
    useState(false);
  const [openSettingsDialog, setOpenSettingsDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const username = useSelector(selectUsername);
  const currentOrganization = useSelector(selectCurrentOrganization);
  const id = "PiUserButton";

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    if (!openSwitchOrganizationDialog && !openSettingsDialog) {
      setOpenAccountDialog(!openAccountDialog);
      setAnchorEl(event.currentTarget);
    }
  }
  function switchOrganizationButtonClicked() {
    setOpenOrganizationDialog(true);
  }

  function switchOrganizationConfirm() {
    setOpenOrganizationDialog(false);
  }

  return (
    <>
      <button
        className={classNames(
          "flex overflow-hidden justify-center items-center gap-[8px] rounded-[5px] h-[48px] hover:bg-creator-primary-washed",
          {
            "w-[32px] pl-[8px]": !props.isMenuExpanded,
            "px-[8px]": props.isMenuExpanded,
          }
        )}
        area-aria-describedby={id}
        onClick={(event) => handleClick(event)}
      >
        <div className="text-[24px] h-full !w-[32px] flex justify-center items-center">
          <AccountCircleOutlinedIcon fontSize="inherit" />
        </div>
        <div className="pi-accountbutton-text">
          <div className="pi-accountbutton-username">{username}</div>
          <div className="pi-accountbutton-organizationName">
            {currentOrganization?.name}
          </div>
        </div>
      </button>
      <PiAccountDialog
        id={id}
        anchorEl={anchorEl}
        open={openAccountDialog}
        onClose={() => setOpenAccountDialog(false)}
        switchOrgCallback={switchOrganizationButtonClicked}
        settingsCallback={() => setOpenSettingsDialog(true)}
      />
      <PiSwitchOrganizationDialog
        open={openSwitchOrganizationDialog}
        onConfirm={switchOrganizationConfirm}
      />
      {/* The dashboard has no rail, so this is its only route into settings. */}
      <SettingsModal
        open={openSettingsDialog}
        onClose={() => setOpenSettingsDialog(false)}
      />
    </>
  );
}
